export const value = {
    USD:2000,
    INR:80,
    USDINR:80,
    agencyComm:0.1,
    familyComm:0.05
}